export default {
    typography: {
        '*': {
            fontFamily: 'Raleway'
        },
        'learnworlds-main-text':{
            fontFamily: 'Raleway'
        },
        'learnworlds-heading':{
            fontFamily: 'Poppins'
        },
        'learnworlds-subheading':{
            fontFamily: 'Poppins'
        },
        'learnworlds-heading3':{
            fontFamily: 'Poppins'
        },
        'learnworlds-heading4':{
            fontFamily: 'Poppins'
        },
        'learnworlds-button':{
            fontFamily: 'Poppins'
        },
        'learnworlds-input':{
            fontFamily: 'Poppins'
        },
        'learnworlds-heading-large':{
            fontSize: 48,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'none',
        },
        'learnworlds-heading-normal': {
            fontSize: 36,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'none',
        },
        'learnworlds-heading-small': {
            fontSize: 26,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'none',
        },
        'learnworlds-subheading-large': {
            fontSize: 36,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'none',
        },
        'learnworlds-subheading-normal': {
            fontSize: 24,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'none',
        },
        'learnworlds-subheading-small': {
            fontSize: 21,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'none',
        },
        'learnworlds-heading3-large': {
            fontSize: 24,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'none',
        },
        'learnworlds-heading3-normal': {
            fontSize: 21,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'none',
        },
        'learnworlds-heading3-small': {
            fontSize: 18,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'none',
        },
        'learnworlds-heading4-large': {
            fontSize: 21,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'uppercase'
        },
        'learnworlds-heading4-normal': {
            fontSize: 18,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'uppercase'
        },
        'learnworlds-heading4-small': {
            fontSize: 14,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.35,
            textTransform: 'uppercase'
        },
        'learnworlds-main-text-huge': {
            fontSize: 74,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-very-large': {
            fontSize: 50,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-large': {
            fontSize: 21,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-normal': {
            fontSize: 18,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-small': {
            fontSize: 16,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-very-small': {
            fontSize: 14,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-tiny': {
            fontSize: 12,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-overline-text': {
            fontFamily: 'Poppins',
            fontSize: 14,
            fontWeight: 'bold',
            letterSpacing: 0.05,
            lineHeight: 1.55,
            textTransform: 'uppercase'
        },
        'learnworlds-quote-text': {
            fontFamily: 'Poppins',
            fontSize: 27,
            fontWeight: 'normal',
            letterSpacing: 0.1,
            lineHeight: 1.55,
            textTransform: 'none'
        }
    },
    input: {
        'learnworlds-button-large': {
            fontSize: 21,
            fontWeight: 'bold',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 20,
            paddingRight: 38,
            paddingBottom: 20,
            paddingLeft: 38
        },
        'learnworlds-button-normal': {
            fontSize: 18,
            fontWeight: 'bold',
            letterSpacing: 0,            
            textTransform: 'none',
            paddingTop: 15,
            paddingRight: 28,
            paddingBottom: 15,
            paddingLeft: 28
        },
        'learnworlds-button-small': {
            fontSize: 16,
            fontWeight: 'bold',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 9,
            paddingRight: 20,
            paddingBottom: 9,
            paddingLeft: 20
        },
        'learnworlds-input-large': {
            fontSize: 21,
            lineHeight: 1,
            fontWeight: 'normal',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 18,
            paddingRight: 18,
            paddingBottom: 18,
            paddingLeft: 18
        },
        'learnworlds-input-normal': {
            fontSize: 18,
            lineHeight: 1,
            fontWeight: 'normal',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 15,
            paddingRight: 15,
            paddingBottom: 15,
            paddingLeft: 15
        },
        'learnworlds-input-small': {
            fontSize: 16,
            lineHeight: 1,
            fontWeight: 'normal',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 12,
            paddingRight: 12,
            paddingBottom: 12,
            paddingLeft: 12
        }
    },
    colors: {
        'lw-brand-bg': {
            color: '#3960F2',
            textType: 'light',
            lessVars: {
                'brand-color': '#3960F2',
                'text-over-brandbg-color' : '@light-text-color'
            }
        },
        'lw-dark-bg': {
            color: '#18364A',
            textType: 'light',
            lessVars: {
                'dark-bg-color': '#18364A',
                'text-over-darkbg-color' : '@light-text-color'
            }
        },
        'lw-light-bg': {
            color: '#F3F8FC',
            textType: 'dark',
            lessVars: {
                'light-bg-color': '#F3F8FC',
                'text-over-lightbg-color' : '@dark-text-color'
            }
        },
        'lw-brand-accent1-bg': {
            color: '#E45151',
            textType: 'light',
            lessVars: {
                'brand-accent1-color': '#E45151',
                'text-over-brandaccent1bg-color' : '@light-text-color'
            }
        },
        'lw-brand-accent2-bg': {
            color: '#FFD366',
            textType: 'dark',
            lessVars: {
                'brand-accent2-color': '#FFD366',
                'text-over-brandaccent2bg-color' : '@dark-text-color'
            }
        },
        'lw-body-bg': {
            color: 'white',
            textType: 'dark',
            lessVars: {
                'body-bg-color': 'white',
                'text-over-bodybg-color' : '@dark-text-color'
            }
        },
        'lw-light-text': {
            color: '#ffffff',
            lessVars: {
                'lw-light-text': '#ffffff',
            }
        },
        'lw-dark-text': {
            color: '#18364a',
            lessVars: {
                'lw-dark-text': '#18364a',
            }
        },
        'lw-link-text': {
            color: '#3960F2',            
            lessVars: {
                'link-text-color': '#3960F2',
            }
        }
    }
}